// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"825":"04b64a23","833":"4ad11bc3"}[chunkId] + ".chunk.js";
};